import limitService from "../../services/productService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new limitService();

export const getProductList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.GET_PRODUCT,
      payload: { loading: true },
    });
    service
      .getProductData(data)
      .then((res) => {
        dispatch({
          type: types.GET_PRODUCT,
          payload: { data: res.data.data, loading: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.GET_PRODUCT, //todo change wih api status
          payload: {
            ...initialState,
            msg: error.message || "Error fetching limit data",
            loading: false,
            next: false,
          },
        });
      });
  };
};

export const AddProduct = (data, obj) => {
  return (dispatch) => {
     dispatch({
       type: types.ADD_PRODUCT,
       payload: { ...initialState, loading: true },
     });
     return service
       .addProduct(data, obj)
       .then((res) => {
         dispatch({
           type: types.ADD_PRODUCT,
           payload: {
             data: res.data.data,
             message: res.data.message,
             status: 200,
             loading: false,
           },
         });
         return res;
       })
       .catch((error) => {
         dispatch({
           type: types.ADD_PRODUCT,
           payload: {
             ...initialState,
             message: error.message || "Error fetching data",
             loading: false,
             status: error.response?.status || 500,
           },
         });
         throw error
       });
   };
};

export const DeleteProduct = (data) => {
    return (dispatch) => {
      dispatch({
        type: types.DELETE_PRODUCT,
        payload: { ...initialState, loader: true },
      });
      return service
        .deleteProduct(data)
        .then((res) => {
          dispatch({
            type: types.DELETE_PRODUCT,
            payload: {
              data: res.data.data,
              message: res.data.message,
              status: 200,
              loading: false,
            },
          });
          return res;
        })
  
        .catch((error) => {
          dispatch({
            type: types.DELETE_PRODUCT,
            payload: {
              ...initialState,
              message: error.message || "Error fetching data",
              loading: false,
              status: error.response?.status || 500,
            },
          });
           throw error
        });
    };
};


export const UpdateProduct = (params, payload) => {
 return (dispatch) => {
     dispatch({
       type: types.UPDATE_PRODUCT,
       payload: { ...initialState, loading: true },
     });
    return service
       .updateProduct( params, payload)
       .then((res) => {
         dispatch({
           type: types.UPDATE_PRODUCT,
           payload: {
             data: res.data.data,
             message: res.data.message,
             status: 200,
             loading: false,
           },
         });
         return res
       })
       .catch((error) => {
         dispatch({
           type: types.UPDATE_PRODUCT,
           payload: {
             ...initialState,
             message: error.message || "Error fetching data",
             loading: false,
             status: error.response?.status || 500,
           },
         });
         throw error;
       });
   };
};


export const ApproveProduct = (data) => {
    return (dispatch) => {
      dispatch({
        type: types.APPROVE_PRODUCT,
        payload: { ...initialState, loading: true },
      });
      return service
        .approveProduct(data)
        .then((res) => {
          dispatch({
            type: types.APPROVE_PRODUCT,
            payload: {
              data: res.data.data,
              message: res.data.message,
              status: 200,
              loading: false,
            },
          });
          return res;
        })
  
        .catch((error) => {
          dispatch({
            type: types.APPROVE_PRODUCT,
            payload: {
              ...initialState,
              message: error.message || "Error fetching data",
              loading: false,
              status: error.response?.status || 500,
            },
          });
           throw error
        });
    };
};